import { apiClient } from "@api/client";
import { request } from "@api/request";
import type { components } from "@api/schema";

/** Mirrors brian's `PhoneNumberLabel` (models/client_phone_number.py). */
type PhoneNumberLabel = components["schemas"]["PhoneNumberLabel"];

/** Mirrors brian's `ClientPhoneNumberOut` (modules/client/schemas.py). */
export interface ClientPhoneNumber {
  id: string;
  label: PhoneNumberLabel;
  numberE164: string;
  isPrimary: boolean;
}

const LABELS: Record<PhoneNumberLabel, string> = {
  mobile: "Mobile",
  home: "Home",
  work: "Work",
  unspecified: "Phone",
};

export const phoneNumberLabel = (label: PhoneNumberLabel): string =>
  LABELS[label];

const toClientPhoneNumber = (
  n: components["schemas"]["ClientPhoneNumberOut"],
): ClientPhoneNumber => ({
  id: n.uuid,
  label: n.label,
  numberE164: n.number_e164,
  isPrimary: n.is_primary,
});

/** Primary first. */
export const fetchClientPhoneNumbers = (
  clientUuid: string,
): Promise<ClientPhoneNumber[]> =>
  request(() =>
    apiClient.GET("/clients/{client_uuid}/phone-numbers", {
      params: { path: { client_uuid: clientUuid } },
    }),
  ).then((rows) => rows.map(toClientPhoneNumber));

export const fetchPatientClientUuid = (
  patientUuid: string,
): Promise<string | null> =>
  request(() =>
    apiClient.GET("/patients/{patient_uuid}", {
      params: { path: { patient_uuid: patientUuid } },
    }),
  ).then((patient) => patient.primary_client_uuid);
